<wre-google-tag-manager></wre-google-tag-manager>
<div [ngClass]="{'hidden': !this.adminService.pageIsLoading}">
    <div style="height: 100vh;" class="d-flex align-items-center justify-content-center">
        <div class="loading"></div>
    </div>
</div>
<div [ngClass]="{'hidden': this.adminService.pageIsLoading}">
    <router-outlet (activate)="this.adminService.pageIsLoading = false;"></router-outlet>
</div>
